import React, { useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import TestimonialVideo from "../testimonial-video/testimonialVideo";
import * as styles from "./testimonialVideoSection.module.css";
import CTAButton from "../cta-button/ctaButton";

export default ({ node }) => {
  const { testimonialSectionVideo, actionButton } = node;
  const [selectedVideo, setSelectedVideo] = useState(0);
  let firstTestimonialVideoURL = "";
  if (testimonialSectionVideo && testimonialSectionVideo.length > 0) {
    firstTestimonialVideoURL =
      testimonialSectionVideo[selectedVideo].testimonialVideoUrl;
  }

  const handleClick = (index) => {
    console.log(index);
    setSelectedVideo(index);
  };

  return (
    <Box className={styles.testimonialSectionBox}>
      <Box pl={{ xs: 2, sm: 2, md: 4 }} pr={{ xs: 2, sm: 2, md: 4 }}>
        <Box md={2}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={6}>
              <iframe
                className={styles.testimonialVideoIframe}
                src={firstTestimonialVideoURL}
              ></iframe>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              {testimonialSectionVideo.map((item, index) => {
                return (
                  <Box mb={1}>
                    <TestimonialVideo
                      node={item}
                      clickHandler={() => handleClick(index)}
                      bgColor={selectedVideo === index ? "#4574c6" : "#fff"}
                      titleColor={selectedVideo === index ? "#fff" : "#000"}
                      watchColor={selectedVideo === index ? "#fff" : "#4574c6"}
                    />
                  </Box>
                );
              })}
            </Grid>
          </Grid>
        </Box>
        {actionButton ? (
          <Box  mt={2}>
            <CTAButton node={actionButton} />
          </Box>
        ) : null}
      </Box>
    </Box>
  );
};
